import React, { Fragment, useContext } from 'react'
import PropTypes from 'prop-types'
import { withRouter } from 'react-router-dom'
import qs from 'qs'
import get from 'lodash/get'

import {
  Container,
  ErrorNoteContainer,
  ErrorNoteTitle,
  ErrorNoteDescrption,
  ErrorNoteLink,
  InfoSectionImgAbs,
  ImgsContainer,
  OrderPartyButton,
} from './styled'
import Menus from './Menus'
import VendorHeader from './VendorHeader'
import VenueImage from 'components.v2/VenueImage'
import ViewOrder from './ViewOrder'
import ViewMultiVendorOrder from './ViewOrder'
import config from 'config'
import { isMultiVendor as isMultiVendorEnv } from 'utils/multiVendor'
import VenueGenericImage from 'components.v2/VenueGenericImage'
import { STATUS_CLOSED, STATUS_OFFLINE } from 'pages/vendor/const'
import ReactContentLoader from 'react-content-loader'
import CreateOrderParty from '../OrderParty/CreateOrderParty'
import { ConfigContext } from 'contexts/config-context'
import isNode from 'detect-node'
import { getQueryParams } from 'utils/url'
import { isWhiteLabel } from 'utils/whiteLabel'
import { isMultiVendor } from 'utils/multiVendor'
class Mobile extends React.Component {
  goToOrder = () => {
    const { info } = this.props
    const qStr = getQueryParams(this.props.history.location.search)
    const isGfoOrder =
      get(qStr, 'channel') === 'gfo_redirect' &&
      !(isWhiteLabel() || isMultiVendor())
    get(info, 'isMultiVendor') && isMultiVendorEnv()
      ? this.props.history.push(`/order/review`)
      : this.props.history.push(
          `/order/${this.props.match.params.id}/review${
            isGfoOrder ? '?channel=gfo_redirect' : ''
          }`,
        )
  }

  render() {
    const {
      selectedOrders,
      info,
      history,
      openModal,
      orderQuantity,
      orderPrice,
      precinct,
      combinedSelectedOrders,
      combinedSubTotalAmount,
      combinedFeesAmount,
      combinedOrdersQuantity,
      combinedDiscountAmount,
      isLoading,
      isOrderPartyEnabled,
    } = this.props
    const { status, logoImage, name } = info
    const isOffline = status === STATUS_CLOSED || status === STATUS_OFFLINE

    return (
      <Fragment>
        <VendorHeader
          history={history}
          {...info}
          isOffline={isOffline}
          precinct={precinct}
        />
        {isLoading && (
          <Fragment>
            <div style={{ background: '#f2f2f2' }}>
              <ReactContentLoader height="160">
                <circle cx="48" cy="116" r="32" />
              </ReactContentLoader>
            </div>
            <ReactContentLoader height="60">
              <rect x="12" y="6" height="20" width="123" rx="4" ry="4" />
              <rect x="171" y="12" height="12" width="92" rx="0" ry="0" />
              <rect x="303" y="12" height="12" width="92" rx="0" ry="0" />
            </ReactContentLoader>

            <ReactContentLoader height="441">
              <rect x="12" y="16" rx="0" ry="0" width="185" height="18" />
              <rect x="12" y="76" rx="0" ry="0" width="140" height="12" />
              <rect x="12" y="96" rx="0" ry="0" width="228" height="12" />
              <rect x="12" y="118" rx="0" ry="0" width="201" height="12" />
              <rect x="284" y="76" rx="12" ry="12" width="88" height="88" />
              <rect x="12" y="170" rx="0" ry="0" width="67" height="12" />
              <rect x="12" y="210" rx="0" ry="0" width="140" height="12" />
              <rect x="12" y="234" rx="0" ry="0" width="228" height="12" />
              <rect x="12" y="256" rx="0" ry="0" width="200" height="12" />
              <rect x="284" y="210" rx="12" ry="12" width="88" height="88" />
            </ReactContentLoader>
          </Fragment>
        )}
        {!isLoading && (
          <Container isOffline={isOffline}>
            {info.id && (
              <ImgsContainer>
                <VenueImage
                  shouldUseCoverImg
                  ratio={[960, 420]}
                  hasStatus={false}
                  {...info}
                />

                <OrderPartyButton>
                  {isOrderPartyEnabled && <CreateOrderParty />}
                </OrderPartyButton>

                {logoImage && (
                  <InfoSectionImgAbs>
                    <VenueGenericImage
                      image={logoImage}
                      name={name}
                      dimensions={{
                        image: { width: 200, height: 200 },
                        style: { width: 64, height: 64 },
                      }}
                      isCirle={true}
                    />
                  </InfoSectionImgAbs>
                )}
              </ImgsContainer>
            )}
            <Menus
              addToOrder={this.addToOrder}
              selectedOrders={selectedOrders}
              openModal={openModal}
              isOffline={isOffline}
            />
            <ErrorNoteContainer>
              <ErrorNoteTitle>Found an error?</ErrorNoteTitle>
              <ErrorNoteDescrption>
                Help us make Hey You better for everyone by reporting any errors
                you’ve found.
              </ErrorNoteDescrption>
              <ErrorNoteLink
                href={`${config.REPORT_ERROR_LINK}?${qs.stringify({
                  Name_of_venue: get(info, 'name'),
                })}`}
                target="_blank"
                rel="noopener"
              >
                Report now →
              </ErrorNoteLink>
            </ErrorNoteContainer>
          </Container>
        )}

        {isMultiVendorEnv() && get(combinedSelectedOrders, 'length') > 0 ? (
          <ViewMultiVendorOrder
            orderQuantity={combinedOrdersQuantity}
            orderPrice={combinedSubTotalAmount}
            orderFees={combinedFeesAmount}
            orderDiscount={combinedDiscountAmount}
            goToOrder={this.goToOrder}
          />
        ) : !isMultiVendorEnv() && selectedOrders.length > 0 ? (
          <ViewOrder
            orderQuantity={orderQuantity}
            orderPrice={orderPrice}
            goToOrder={this.goToOrder}
          />
        ) : (
          <div />
        )}
      </Fragment>
    )
  }
}

Mobile.propTypes = {
  orderQuantity: PropTypes.number,
  orderPrice: PropTypes.number,
  match: PropTypes.object,
  info: PropTypes.object,
  history: PropTypes.object,
  selectedOrders: PropTypes.array,
  openModal: PropTypes.func,
}

const MobileWrappper = props => {
  if (isNode) return null

  const config = useContext(ConfigContext)
  const isOrderPartyEnabled = get(config, 'features.order_party.enabled')
  return <Mobile isOrderPartyEnabled={isOrderPartyEnabled} {...props} />
}

export default withRouter(MobileWrappper)
